"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.newFormValues = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Availability_styles_1 = __importDefault(require("./Availability.styles"));
var StepOne_1 = __importDefault(require("./StepOne/StepOne"));
var Intro_1 = __importDefault(require("./Intro/Intro"));
var StepTwo_1 = __importDefault(require("./StepTwo/StepTwo"));
var Confirmation_1 = __importDefault(require("./Confirmation/Confirmation"));
var InputDayRange_1 = require("../../atoms/InputDayRange/InputDayRange");
var loginState_1 = require("../../../types/loginState");
var useHideSidebar_1 = __importDefault(require("../../../hooks/useHideSidebar"));
exports.newFormValues = {
    daysNotAvailable: { value: [] },
    rangesNotAvailable: { value: [InputDayRange_1.emptyRange] },
};
var Availability = function (_a) {
    var loggedIn = _a.loggedIn, username = _a.username;
    var _b = react_1.useState(0), step = _b[0], setStep = _b[1];
    var _c = react_1.useState(exports.newFormValues), formState = _c[0], setFormState = _c[1];
    // const [ableToSubmit, setAbleToSubmit] = useState<Boolean>(true);
    // const [errorState, setErrorState] = useState<Boolean>(false);
    // const [responseErrors, setResponseErrors] = useState<any>({});
    // const [successState, setSuccessState] = useState<Boolean>(false);
    useHideSidebar_1.default();
    react_1.useEffect(function () {
        if (window.location.hash === '#step2') {
            setStep(2);
        }
    }, []);
    var handleInputChange = function (id, newValue) {
        setFormState(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[id] = {
                value: newValue,
                error: '',
            }, _a)));
        });
    };
    react_1.useEffect(function () {
        if (step === 2) {
            // handleAvailabilitySubmit();
        }
    }, [step]);
    if (loggedIn !== loginState_1.LOGGEDIN) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/login" });
    }
    return (react_1.default.createElement(Availability_styles_1.default, { className: "availability" },
        step === 0 && react_1.default.createElement(Intro_1.default, { username: username, setStep: function () { return setStep(1); } }),
        step === 1 && (react_1.default.createElement(StepOne_1.default, { formState: formState, setStep: function () { return setStep(2); }, handleInputChange: handleInputChange })),
        step === 2 && (react_1.default.createElement(StepTwo_1.default, { formState: formState, setStep: function (stepParam) { return setStep(stepParam); }, handleInputChange: handleInputChange })),
        step === 3 && react_1.default.createElement(Confirmation_1.default, { setStep: function () { return setStep(4); } }),
        step === 4 && react_1.default.createElement(react_router_dom_1.Redirect, { to: "/agenda" })));
};
exports.default = Availability;
